import classNames from "classnames";
import React, { useState } from "react";
import ATitle from "../../components/ATitle";
import useDropdown from "../../components/hooks/useDropdown";
import Search from "../../components/Search";
import Wrapper from "../../components/Wrapper";
import { farm } from "../../placeholder";
import { currencies, sf, pools, riskPools } from "./currencies";

const Item = ({ item, style = {} }) => {
  const [ref, styles, open, setOpen] = useDropdown({ speed: 100 });

  return (
    <div
      className={classNames("farm-item pools_risk_items", { opened: open })}
      style={style}
      key={item.id}
    >
      <div className="farm-item__rate">
        <div className="farm-item__rate-wrapper">
          <span className="farm-item__rate-number">C{item.first.tier}</span>
          <span className="farm-item__rate-separator">/</span>
          <span className="farm-item__rate-number">C{item.second.tier}</span>
        </div>
      </div>
      <div className="farm-item__content">
        <div className="farm-item__information">
          <div className="farm-item__col farm-item__col_currency">
            <span className="farm-item__col-title">Pool</span>
            <span className="farm-item__col-value pools_images">
              <img
                src={item.first.icon}
                alt="icon"
                className="farm-item__col-icon"
              />
              <img
                src={item.second.icon}
                alt="icon"
                className="farm-item__col-icon"
              />
              <div className="farm-item__col-name">
                {item.first.name + "/" + item.second.name}
              </div>
            </span>
          </div>
          <div className="farm-item__col farm-item__col_info pools_info">
            <div className="farm-info">
              <span className="farm-info__title">Liq. Fees (earned)</span>
              <span className="farm-info__value">0.0 $</span>
            </div>
            <div className="farm-info">
              <span className="farm-info__title">Average Pool Balance</span>
              <span className="farm-info__value">0.0</span>
            </div>
            <div className="farm-info">
              <span className="farm-info__title">Total liquidity</span>
              <span className="farm-info__value">53,241,455 $</span>
            </div>
            <div className="farm-info">
              <span className="farm-info__title">Share</span>
              <span className="farm-info__value">0.1 %</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default function () {
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("ASC");
  const [activeRisk, setActiveRisk] = useState("low");

  return (
    <div className="farm pools_risk">
      <header className="farm__header swap_header">
        <div className="swap_token_balance">
          <h4>LP Token Balance</h4>
          <div>
            0.3
            <span>HR WBNB</span>
          </div>
        </div>
        <div className="swap_token_balance_buttons">
          <button
            onClick={() => setActiveRisk("low")}
            className={activeRisk === "low" ? "active" : null}
          >
            Low Risk
          </button>
          <button
            onClick={() => setActiveRisk("high")}
            className={activeRisk === "high" ? "active" : null}
          >
            High Risk
          </button>
        </div>
        <Search
          className="farm__search"
          placeholder="Search"
          name="search"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </header>
      <div className="farm-list">
        {/* <div className="swap-sort">
          <div className="sort">
            <div className="sort__text">Sort by TVL</div>
            <button
              className={classNames("sort__btn sort__btn_asc", {
                active: sort === "ASC",
              })}
              onClick={setSort.bind(null, "ASC")}
            ></button>
            <button
              className={classNames("sort__btn sort__btn_desc", {
                active: sort === "DESC",
              })}
              onClick={setSort.bind(null, "DESC")}
            ></button>
          </div>
        </div> */}
        <div className="farm-list__wrapper">
          <Wrapper
            className="farm-list__items custom-scrollbar"
            marginTop={20}
            showItems={5}
          >
            {riskPools.map((item) => (
              <Item item={item} key={item.id} />
            ))}
          </Wrapper>
        </div>
      </div>
    </div>
  );
}
